import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class RegulationsStageTagsApi extends ApiModule {
	constructor() {
		super(ModulesMap.REGULATIONS_STAGE_TAGS, {
			entity: 'regulations_stage_tags',
		})
	}
}
